import React, { useState, useEffect } from 'react';
import "../../../assets/css/user/BannerCarousel.css";

const BannerCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = 4;

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => clearInterval(interval);
  }, [currentSlide]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowLeft') prevSlide();
      if (e.key === 'ArrowRight') nextSlide();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [currentSlide]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="carousel-container">
      <div 
        className="carousel-wrapper" 
        style={{ transform: `translateX(-${currentSlide * 100}%)` }}
      >
        {/* Slide 1: Cosmetics */}
        <div className="carousel-slide slide-1">
          <div className="palm-leaf palm-left">🌿</div>
          <div className="palm-leaf palm-right">🌿</div>
          <div className="palm-leaf palm-bottom">🌿</div>
          
          <div className="product-section">
            <div className="product-display">
              <div className="product-items">
                <div className="product-box" style={{ height: '100px' }}>💄</div>
                <div className="product-box" style={{ height: '140px' }}>✨</div>
                <div className="product-box" style={{ height: '110px' }}>💅</div>
              </div>
            </div>
          </div>

          <div className="text-section">
            <div className="badge">EXCLUSIVE OFFER</div>
            <div className="main-title">COSMETICS</div>
            <div className="subtitle">KEEP YOURSELF BEAUTIFUL</div>
            <div className="offer-box">
              <span className="offer-text">Up to</span>
              <span className="offer-percent">50%</span>
            </div>
          </div>
        </div>

        {/* Slide 2: Fashion */}
        <div className="carousel-slide slide-2">
          <div className="fashion-content">
            <div className="fashion-title">SUMMER FASHION</div>
            <div className="fashion-subtitle">Trending Styles & Latest Collections</div>
            <button className="cta-button">Shop Now →</button>
          </div>
          <div className="fashion-image">👗</div>
        </div>

        {/* Slide 3: Electronics */}
        <div className="carousel-slide slide-3">
          <div className="electronics-grid">
            <div className="product-card">
              <div className="product-icon">📱</div>
              <div className="product-name">Smartphones</div>
              <div className="product-price">30% OFF</div>
            </div>
            <div className="product-card">
              <div className="product-icon">💻</div>
              <div className="product-name">Laptops</div>
              <div className="product-price">25% OFF</div>
            </div>
            <div className="product-card">
              <div className="product-icon">🎧</div>
              <div className="product-name">Headphones</div>
              <div className="product-price">40% OFF</div>
            </div>
            <div className="product-card">
              <div className="product-icon">⌚</div>
              <div className="product-name">Smart Watch</div>
              <div className="product-price">35% OFF</div>
            </div>
          </div>
          <div className="electronics-text">
            <div className="electronics-title">TECH DEALS</div>
            <div className="electronics-desc">Latest Gadgets at Unbeatable Prices</div>
            <button className="cta-button">Explore Now →</button>
          </div>
        </div>

        {/* Slide 4: Food & Dining */}
        <div className="carousel-slide slide-4">
          <div className="food-title">FOOD FESTIVAL</div>
          <div className="food-subtitle">Delicious Deals on Your Favorite Meals</div>
          <div className="food-items">
            <div className="food-item">🍕</div>
            <div className="food-item">🍔</div>
            <div className="food-item">🍰</div>
            <div className="food-item">🍜</div>
          </div>
          <button className="cta-button">Order Now →</button>
        </div>
      </div>

      {/* Navigation Arrows */}
      <div className="arrow-btn arrow-left" onClick={prevSlide}>‹</div>
      <div className="arrow-btn arrow-right" onClick={nextSlide}>›</div>

      {/* Dots Navigation */}
      <div className="carousel-controls">
        {[...Array(totalSlides)].map((_, index) => (
          <div
            key={index}
            className={`control-dot ${currentSlide === index ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default BannerCarousel;